import { render } from "./AgeChooser.vue?vue&type=template&id=33d5c1af&scoped=true"
import script from "./AgeChooser.vue?vue&type=script&lang=js"
export * from "./AgeChooser.vue?vue&type=script&lang=js"

import "./AgeChooser.vue?vue&type=style&index=0&id=33d5c1af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d5c1af"]])

export default __exports__